import { API_BASE_URL_ENV } from "helpers/common";
import http from "../HttpService";

const apiReceiptEndPoint=API_BASE_URL_ENV() + "/admin/crm/upload-receipt"; 
 

export default class ReseiptService {
    uploadReciept= (data) => {
        return http.post(apiReceiptEndPoint, data);
    }
}
